import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            submit: 'onSubmit'
        }
    }

    init() {
        this.urlRedirect = this.el.action;
    }

    onSubmit(event) {
        event.preventDefault();

        let url = window.location.href;

        //Retrieve FormData
        const formData = new FormData(event.target);

        //Clear empty fields from FormData
        for (const entry of Array.from(formData.entries())) {
            if(!entry[1]) {
                formData.delete(entry[0])
            }
        }

        //Create parameters string
        const parametersString = new URLSearchParams(formData).toString();

        if(this.urlRedirect) {
            url = this.urlRedirect
        }

        //Construct final URL
        const queryUrl = (parametersString.length > 0) ? `${url.split('?')[0]}?${parametersString}` : url.split('?')[0]

        // Launch transition
        this.call('goTo', { url: queryUrl }, 'Load')
    }

    destroy() {
        super.destroy();
    }
}
